// Camion des bulles animées du menu Plus : tracteur conventionnel et remorque à moulée en aluminium, citerne
// en coupe (même dessin que les maquettes d'animation du Dispatch). 1 m ≈ 65 unités, sol à y = 360.
// draw(état) affiche un instant précis : couches de commandes par compartiment, plafonds, couvercles, chute de chargement.
// Le dompeur (createDumpTruck) garde le même tracteur et tire une benne basculante, elle aussi en coupe.

const G = { ground: 360, wy: 327, top: 104, wall: 236, outlet: 274, auger: 290, gap: 6, x0: 352, x1: 1222, lidY: 86, rearX: 1246, pivotY: 56, boom: 210 };
export const TRUCK_VIEWBOX = [-4, -40, 1272, 412];

const polyArea = (pts) => Math.abs(pts.reduce((s, [x, y], i) => { const [x2, y2] = pts[(i + 1) % pts.length]; return s + x * y2 - x2 * y; }, 0)) / 2;
function clipBelow(pts, level) {
  const out = [];
  pts.forEach((a, i) => {
    const b = pts[(i + 1) % pts.length];
    const ain = a[1] >= level, bin = b[1] >= level;
    if (ain) out.push(a);
    if (ain !== bin) { const k = (level - a[1]) / (b[1] - a[1]); out.push([a[0] + k * (b[0] - a[0]), level]); }
  });
  return out;
}
// Hauteur du grain pour une fraction du volume : la trémie du bas se remplit d'abord.
function levelFor(comp, frac) {
  if (frac <= 0) return G.outlet;
  let lo = G.top, hi = G.outlet;
  for (let k = 0; k < 26; k++) {
    const mid = (lo + hi) / 2;
    if (polyArea(clipBelow(comp.poly, mid)) / comp.area > frac) lo = mid; else hi = mid;
  }
  return (lo + hi) / 2;
}
function geometry(capacities, x1 = G.x1) {
  const total = capacities.reduce((s, cap) => s + cap, 0);
  const usable = x1 - G.x0 - G.gap * (capacities.length - 1);
  let x = G.x0;
  return capacities.map((cap, i) => {
    const w = (cap / total) * usable;
    const c = { pos: i + 1, cap, x0: x, x1: x + w, cx: x + w / 2 };
    c.poly = [[c.x0, G.top], [c.x1, G.top], [c.x1, G.wall], [c.cx + 8, G.outlet], [c.cx - 8, G.outlet], [c.x0, G.wall]];
    c.area = polyArea(c.poly);
    x += w + G.gap;
    return c;
  });
}

let grainCache = "";
function grainUrl() {
  if (grainCache) return grainCache;
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 160;
  const g = canvas.getContext("2d");
  for (let i = 0; i < 3000; i++) {
    const r = 0.6 + Math.random() * 1.2, a = Math.random() * 0.5;
    g.fillStyle = Math.random() < 0.55 ? `rgba(0,0,0,${a})` : `rgba(255,255,255,${a * 0.6})`;
    g.beginPath();
    g.ellipse(Math.random() * 160, Math.random() * 160, r * 1.5, r, Math.random() * Math.PI, 0, Math.PI * 2);
    g.fill();
  }
  grainCache = canvas.toDataURL();
  return grainCache;
}

let instance = 0;

// Rebord d'aluminium de même épaisseur tout autour de la trémie : chaque arête du compartiment est décalée
// vers l'extérieur, et deux arêtes voisines se croisent au coin du rebord.
const RIM = 3;
function rimCorner([ax, ay], [bx, by], [cx, cy]) {
  const edge = (px, py, qx, qy) => {
    const length = Math.hypot(qx - px, qy - py);
    const nx = (qy - py) / length, ny = -(qx - px) / length;
    return { x: px + nx * RIM, y: py + ny * RIM, dx: qx - px, dy: qy - py };
  };
  const first = edge(ax, ay, bx, by), second = edge(bx, by, cx, cy);
  const k = ((second.x - first.x) * second.dy - (second.y - first.y) * second.dx) / (first.dx * second.dy - first.dy * second.dx);
  return [first.x + first.dx * k, first.y + first.dy * k];
}
const rimBottom = (c) => {
  const [, topRight, wallRight, outRight, outLeft, wallLeft] = c.poly;
  const topLeft = c.poly[0];
  return [rimCorner(topRight, wallRight, outRight), rimCorner(wallRight, outRight, outLeft), rimCorner(outRight, outLeft, wallLeft), rimCorner(outLeft, wallLeft, topLeft)];
};

const P = (pts) => pts.map((p) => p.map((v) => v.toFixed(1)).join(",")).join(" ");
const tape = (x, y, w) => Array.from({ length: Math.floor(w / 12) }, (_, i) => `<rect x="${x + i * 12}" y="${y}" width="12" height="4" fill="${i % 2 ? "#f1f5f9" : "#dc2626"}"/>`).join("");
const wheel = (u, cx, steer = false) => `
    <g transform="translate(${cx},${G.wy})">
      <circle r="33" fill="${u("tire")}"/><circle r="31.5" fill="none" stroke="#24282d" stroke-width="2.5"/>
      <circle r="21" fill="${u("rim")}"/><circle r="21" fill="none" stroke="#56606b" stroke-width="1.2"/>
      ${Array.from({ length: 8 }, (_, i) => `<ellipse cx="0" cy="-13.2" rx="3" ry="4.4" fill="#1c2026" transform="rotate(${(i / 8) * 360 + 22.5})"/>`).join("")}
      <circle r="${steer ? 8 : 9}" fill="${u("hub")}" stroke="#6b7480" stroke-width=".8"/><circle r="2.6" fill="#94a3b8"/>
    </g>`;
const gradient = (id, name, stops, vertical = true) => `<linearGradient id="${id}-${name}" x1="0" y1="0" x2="${vertical ? 0 : 1}" y2="${vertical ? 1 : 0}">${stops.map(([o, c, a = 1]) => `<stop offset="${o}" stop-color="${c}" stop-opacity="${a}"/>`).join("")}</linearGradient>`;

// Dégradés et motifs communs aux deux remorques ; clips : les zones de grain propres à la remorque.
const defs = (id, clips) => `
    <defs>
      ${gradient(id, "paint", [[0, "#fbfcfd"], [0.34, "#eef1f4"], [0.47, "#c3cad3"], [0.53, "#e3e7ec"], [1, "#9aa3ad"]])}
      ${gradient(id, "alu", [[0, "#f1f4f7"], [0.08, "#c3cad2"], [0.45, "#a3acb6"], [0.55, "#b9c0c8"], [0.92, "#d3d9df"], [1, "#727c87"]])}
      ${gradient(id, "chrome", [[0, "#4b5563"], [0.3, "#f8fafc"], [0.5, "#8f99a4"], [0.78, "#e5e9ee"], [1, "#5f6873"]], false)}
      ${gradient(id, "chromeh", [[0, "#f8fafc"], [0.3, "#a2abb5"], [0.55, "#eef1f4"], [0.8, "#7d8792"], [1, "#4b5563"]])}
      ${gradient(id, "steel", [[0, "#cfd5dc"], [0.45, "#8a939d"], [1, "#4f5862"]])}
      ${gradient(id, "steelv", [[0, "#59626d"], [0.4, "#cfd5dc"], [1, "#626b76"]], false)}
      ${gradient(id, "glass", [[0, "#5b7089"], [0.32, "#1c2735"], [0.6, "#0d131b"], [1, "#1a2430"]])}
      ${gradient(id, "inside", [[0, "#05080c"], [1, "#141b25"]])}
      ${gradient(id, "shade", [[0, "#fff", 0.2], [0.06, "#fff", 0], [1, "#000", 0.45]])}
      <radialGradient id="${id}-tire"><stop offset=".6" stop-color="#2c3035"/><stop offset=".86" stop-color="#17191c"/><stop offset="1" stop-color="#0b0c0e"/></radialGradient>
      <radialGradient id="${id}-rim" cx=".36" cy=".32"><stop offset="0" stop-color="#fff"/><stop offset=".55" stop-color="#c7ced6"/><stop offset=".85" stop-color="#8a939e"/><stop offset="1" stop-color="#5b6470"/></radialGradient>
      <radialGradient id="${id}-hub" cx=".4" cy=".35"><stop offset="0" stop-color="#f8fafc"/><stop offset="1" stop-color="#7d8792"/></radialGradient>
      <pattern id="${id}-grate" patternUnits="userSpaceOnUse" width="8" height="10"><rect width="8" height="10" fill="#4b5563"/><rect x="2" y="2" width="4" height="6" fill="#1f252c"/></pattern>
      <pattern id="${id}-grain" patternUnits="userSpaceOnUse" width="160" height="160"><image href="${grainUrl()}" width="160" height="160"/></pattern>
      ${clips}
    </defs>`;

// Tracteur commun à la citerne et au dompeur.
const tractor = (u) => `
    <g>
      <rect x="40" y="300" width="490" height="12" fill="#1a1e24"/>
      <rect x="388" y="292" width="76" height="9" rx="2" fill="#2b3138"/>
      <path d="M34,238 C34,230 40,227 50,226 L188,216 L192,216 L192,304 L137,304 A46,46 0 0 0 55,304 L40,304 L35,296 Z" fill="${u("paint")}" stroke="#59626d" stroke-width="1"/>
      <path d="M52,233 L188,222" stroke="rgba(255,255,255,.9)" stroke-width="1.6"/>
      <path d="M56,304 A41,41 0 0 1 136,304" fill="#07090c"/>
      <path d="M51,304 A46,46 0 0 1 141,304" fill="none" stroke="#2a2f36" stroke-width="5"/>
      <path d="M45,304 A52,52 0 0 1 147,304" fill="none" stroke="rgba(255,255,255,.75)" stroke-width="1.6"/>
      ${[0, 1, 2, 3, 4, 5].map((i) => `<path d="M${152 + i * 5},242 L${148 + i * 5},264" stroke="#59626d" stroke-width="2.2" stroke-linecap="round"/>`).join("")}
      <rect x="28" y="236" width="10" height="64" rx="2" fill="${u("chrome")}"/>
      <rect x="40" y="250" width="26" height="15" rx="5" fill="${u("chrome")}"/><rect x="43" y="252.5" width="20" height="10" rx="4" fill="#eef4fb"/>
      <rect x="42" y="268" width="10" height="5" rx="1.5" fill="#f59e0b"/>
      <rect x="12" y="272" width="34" height="32" rx="6" fill="${u("chromeh")}"/>
      <rect x="170" y="210" width="22" height="56" rx="11" fill="${u("chrome")}"/>
      <path d="M192,304 L192,216 L203,173 Q206,162 218,162 L284,162 Q292,162 292,171 L292,304 Z" fill="${u("paint")}" stroke="#59626d" stroke-width="1"/>
      <rect x="186" y="214" width="8" height="90" fill="rgba(0,0,0,.12)"/>
      <path d="M196,170 L214,158 L292,158 L292,163 L218,163 L205,173 Z" fill="#1f252c"/>
      ${[226, 242, 258, 274].map((x) => `<rect x="${x - 4}" y="157" width="8" height="5" rx="1.5" fill="#f59e0b"/>`).join("")}
      <path d="M201,214 L211,177 L270,177 L270,214 Z" fill="${u("glass")}" stroke="#2b3138" stroke-width="2.2"/>
      <path d="M199,175 L274,175 Q277,175 277,178 L277,300 L199,300 Z" fill="none" stroke="#8b95a1" stroke-width="1.2"/>
      <rect x="256" y="226" width="14" height="3.5" rx="1.5" fill="${u("chrome")}"/>
      <path d="M200,190 L180,186 M200,226 L180,230" stroke="#9aa3ad" stroke-width="2.6"/>
      <rect x="168" y="174" width="13" height="64" rx="3" fill="#1b2026" stroke="#56606b"/>
      <rect x="196" y="306" width="78" height="30" rx="15" fill="${u("chromeh")}"/>
      <rect x="296" y="94" width="10" height="208" rx="2" fill="${u("chrome")}"/>
      <rect x="293" y="196" width="16" height="70" rx="3" fill="${u("chrome")}"/>
      <path d="M292,238 c6,-10 12,6 16,-4 s10,8 14,-2 s8,6 12,-2" fill="none" stroke="#dc2626" stroke-width="2.6"/>
      <path d="M292,246 c6,-10 12,6 16,-4 s10,8 14,-2 s8,6 12,-2" fill="none" stroke="#2563eb" stroke-width="2.6"/>
    </g>`;

// Roues, ailes et bavettes ; s : allongement de la remorque.
const running = (u, s) => `
    ${wheel(u, 96, true)}${wheel(u, 398)}${wheel(u, 484)}${wheel(u, 1000 + s)}${wheel(u, 1083 + s)}${wheel(u, 1166 + s)}
    <path d="M358,302 C366,284 424,282 441,300 C452,282 512,282 526,302" fill="none" stroke="#111418" stroke-width="7" stroke-linecap="round"/>
    <rect x="528" y="298" width="9" height="52" fill="#0d0f12"/><rect x="${1206 + s}" y="300" width="9" height="52" fill="#0d0f12"/>`;

// Chute de chargement, déplacée au-dessus de la place à remplir.
const spoutMarkup = (u) => `
    <g class="cst-spout" opacity="0">
      <rect x="-12" y="-84" width="24" height="132" fill="${u("steelv")}"/>
      <rect x="-14" y="10" width="28" height="6" fill="#3a414a"/>
      <path d="M-11,48 L11,48 L8,70 L-8,70 Z" fill="#3f4650"/>
      <line class="cst-flow" x1="0" y1="70" x2="0" y2="200" stroke-width="8" opacity="0"/>
    </g>`;

// s : allongement de la remorque (unités) ; tout ce qui est à l'arrière de la citerne se décale d'autant.
function markup(comps, id, viewBox, s = 0) {
  const u = (name) => `url(#${id}-${name})`;
  const shellBottom = [...comps].reverse().flatMap(rimBottom);
  const shell = `M334,118 Q334,96 356,96 L${1226 + s},96 Q${1240 + s},96 ${1240 + s},114 L${1240 + s},${G.wall + 5} ${shellBottom.map(([x, y]) => `L${x.toFixed(1)},${y}`).join(" ")} L334,${G.wall + 5} Z`;
  const partitions = comps.slice(1).map((c) => c.x0 - G.gap / 2);
  const rivets = [G.x0 - 9, ...partitions, comps[comps.length - 1].x1 + 9].map((x) => Array.from({ length: 12 }, (_, i) => `<circle cx="${x.toFixed(1)}" cy="${110 + i * 11}" r="1.1" fill="rgba(0,0,0,.35)"/>`).join("")).join("");
  const comp = comps.map((c) => `
    <g data-pos="${c.pos}">
      <polygon points="${P(c.poly)}" fill="${u("inside")}"/>
      <g clip-path="url(#${id}-clip-${c.pos})">
        ${[0, 1].map((k) => `<path class="cst-fill" data-k="${k}"/><path class="cst-grain" data-k="${k}" fill="${u("grain")}" opacity=".75"/><path class="cst-shade" data-k="${k}" fill="${u("shade")}"/>`).join("")}
        <path class="cst-sep" fill="none" stroke="#fff" stroke-width="4"/>
        <path class="cst-limit" fill="none"/>
      </g>
      <polygon points="${P(c.poly)}" fill="none" stroke="#1d232b" stroke-width="2"/>
      <polygon class="cst-out" points="${P(c.poly)}" fill="none"/>
      ${[0, 1].map((k) => `<text class="cst-layer" data-k="${k}" x="${c.cx}"></text>`).join("")}
      <text class="cst-name" x="${c.cx}" y="20">C${c.pos}</text>
      <rect x="${c.cx - 5}" y="${G.outlet + RIM}" width="10" height="${G.auger - G.outlet - 6 - RIM}" fill="#56606b"/>
      <line class="cst-flow cst-drain" x1="${c.cx}" y1="${G.outlet - 2}" x2="${c.cx}" y2="${G.auger}" stroke-width="6" opacity="0"/>
    </g>`).join("");
  const lids = comps.map((c) => `
    <g class="cst-lid" data-pos="${c.pos}">
      <path d="M${c.cx - 15},${G.lidY} Q${c.cx},${G.lidY - 13} ${c.cx + 15},${G.lidY} Z" fill="${u("alu")}" stroke="#4b5563" stroke-width=".8"/>
      <rect x="${c.cx - 3}" y="${G.lidY - 12}" width="6" height="3" rx="1" fill="#5b6470"/>
    </g>`).join("");
  return `<svg viewBox="${viewBox.join(" ")}" aria-hidden="true">
    ${defs(id, comps.map((c) => `<clipPath id="${id}-clip-${c.pos}"><polygon points="${P(c.poly)}"/></clipPath>`).join(""))}
    ${tractor(u)}
    <g>
      <path d="${shell}" fill="${u("alu")}" stroke="#2b3138" stroke-width="1.2"/>
      <path d="M336,101 L${1238 + s},101" stroke="rgba(255,255,255,.7)" stroke-width="1.4"/>
      ${rivets}
      <rect x="334" y="${G.wall + 5}" width="18" height="50" fill="${u("alu")}" stroke="#2b3138" stroke-width="1"/>
      ${tape(336, G.wall + 30, 14)}
      <line x1="338" y1="72" x2="338" y2="${G.wall}" stroke="#5f6873" stroke-width="2.4"/><line x1="348" y1="72" x2="348" y2="${G.wall}" stroke="#5f6873" stroke-width="2.4"/>
      ${Array.from({ length: 11 }, (_, i) => `<line x1="338" y1="${84 + i * 14}" x2="348" y2="${84 + i * 14}" stroke="#5f6873" stroke-width="2.2"/>`).join("")}
      <rect x="352" y="${G.lidY}" width="${872 + s}" height="10" fill="${u("grate")}"/>
      <line x1="352" y1="68" x2="${1224 + s}" y2="68" stroke="#9aa4af" stroke-width="2.4"/>
      ${lids}
      ${comp}
      <rect x="352" y="${G.auger - 6}" width="${900 + s}" height="13" rx="6.5" fill="${u("steel")}"/>
      <line class="cst-flow cst-tube" x1="352" y1="${G.auger}" x2="${G.rearX + s}" y2="${G.auger}" stroke-width="7" opacity="0"/>
      <rect x="494" y="290" width="18" height="14" rx="2" fill="#2b3138"/><rect x="498" y="300" width="10" height="46" fill="${u("steelv")}"/><rect x="489" y="345" width="28" height="6" rx="1" fill="#2b3138"/>
      <rect x="${950 + s}" y="${G.auger + 6}" width="290" height="11" fill="#22272e"/>
      ${tape(952 + s, G.auger + 8, 284)}
      <rect x="${1234 + s}" y="252" width="6" height="16" rx="1" fill="#dc2626"/>
      <rect x="${G.rearX + s - 9}" y="${G.pivotY - 8}" width="18" height="${G.auger - G.pivotY + 14}" rx="8" fill="${u("steelv")}"/>
      <rect x="${G.rearX + s - G.boom}" y="${G.pivotY - 8}" width="${G.boom}" height="16" rx="8" fill="${u("steel")}"/>
      <circle cx="${G.rearX + s}" cy="${G.pivotY}" r="11" fill="#2b3138" stroke="#7d8792" stroke-width="1.5"/>
    </g>
    ${running(u, s)}
    ${spoutMarkup(u)}
  </svg>`;
}

// stretch : remorque allongée (unités), pour un camion bas et large dans l'infobulle des segments.
export function createCompartmentTruck(host, { capacities, colors, stretch = 0 }) {
  const comps = geometry(capacities, G.x1 + stretch);
  const id = `cst${++instance}`;
  const viewBox = [TRUCK_VIEWBOX[0], TRUCK_VIEWBOX[1], TRUCK_VIEWBOX[2] + stretch, TRUCK_VIEWBOX[3]];
  host.innerHTML = markup(comps, id, viewBox, stretch);
  const svg = host.querySelector("svg");
  const byPos = Object.fromEntries(comps.map((c) => [c.pos, c]));
  const groups = Object.fromEntries(comps.map((c) => [c.pos, svg.querySelector(`[data-pos="${c.pos}"]:not(.cst-lid)`)]));
  const lidEls = Object.fromEntries(comps.map((c) => [c.pos, svg.querySelector(`.cst-lid[data-pos="${c.pos}"]`)]));
  const spout = svg.querySelector(".cst-spout");
  const flow = spout.querySelector(".cst-flow");
  const tube = svg.querySelector(".cst-tube");

  // Couches du bas vers le haut : A, puis B qui complète le compartiment ; un trait blanc les sépare.
  const paint = (c, layers = []) => {
    const g = groups[c.pos];
    const mound = (y) => Math.min(5, (G.outlet - y) * 0.22);
    const curve = (y) => `${c.x0 - 2},${y + mound(y)} Q${c.cx},${y - mound(y)} ${c.x1 + 2},${y + mound(y)}`;
    let below = 0;
    [0, 1].forEach((k) => {
      const layer = layers[k];
      const parts = ["cst-fill", "cst-grain", "cst-shade"].map((cls) => g.querySelector(`.${cls}[data-k="${k}"]`));
      const label = g.querySelector(`.cst-layer[data-k="${k}"]`);
      if (!layer || layer.f <= 0.002) {
        parts.forEach((el) => el.setAttribute("d", ""));
        label.textContent = "";
        if (k === 1) g.querySelector(".cst-sep").setAttribute("d", "");
        return;
      }
      const top = levelFor(c, below + layer.f);
      const bottom = below > 0.002 ? levelFor(c, below) : null;
      const d = `M${curve(top)} ${bottom == null ? `L${c.x1 + 2},${G.outlet + 2} L${c.x0 - 2},${G.outlet + 2}` : `L${c.x1 + 2},${bottom + mound(bottom)} Q${c.cx},${bottom - mound(bottom)} ${c.x0 - 2},${bottom + mound(bottom)}`} Z`;
      parts.forEach((el) => el.setAttribute("d", d));
      parts[0].setAttribute("fill", colors[layer.order]);
      label.setAttribute("y", (((bottom ?? G.outlet - 6) + top) / 2).toFixed(1));
      label.textContent = layer.f > 0.12 ? layer.label : "";
      if (k === 1) g.querySelector(".cst-sep").setAttribute("d", bottom == null ? "" : `M${curve(bottom)}`);
      below += layer.f;
    });
  };

  // drain : { pos, order } qui se vide par le fond et la vis.
  function draw({ fills = {}, lids = {}, spout: chute = null, hot = [], over = [], limits = {}, drain = null }) {
    comps.forEach((c) => {
      paint(c, fills[c.pos]);
      const limit = limits[c.pos] ? levelFor(c, limits[c.pos]) : null;
      groups[c.pos].querySelector(".cst-limit").setAttribute("d", limit == null ? "" : `M${c.x0},${limit.toFixed(1)} L${c.x1},${limit.toFixed(1)}`);
      lidEls[c.pos].setAttribute("transform", `rotate(${(-74 * (lids[c.pos] || 0)).toFixed(1)} ${c.cx + 15} ${G.lidY})`);
      const out = groups[c.pos].querySelector(".cst-out");
      out.dataset.hot = hot.includes(c.pos) ? "true" : "false";
      out.dataset.over = over.includes(c.pos) ? "true" : "false";
      const drainLine = groups[c.pos].querySelector(".cst-drain");
      drainLine.setAttribute("opacity", drain?.pos === c.pos ? "1" : "0");
      if (drain?.pos === c.pos) drainLine.style.stroke = colors[drain.order];
    });
    tube.setAttribute("opacity", drain ? "1" : "0");
    if (drain) {
      tube.setAttribute("x1", byPos[drain.pos].cx.toFixed(1));
      tube.style.stroke = colors[drain.order];
    }
    if (!chute) { spout.setAttribute("opacity", "0"); return; }
    const from = byPos[chute.fromPos] || byPos[chute.pos], to = byPos[chute.pos];
    spout.setAttribute("transform", `translate(${(from.cx + (to.cx - from.cx) * chute.move).toFixed(1)},0)`);
    spout.setAttribute("opacity", chute.alpha.toFixed(2));
    const layers = fills[to.pos] || [];
    flow.setAttribute("y2", (levelFor(to, layers.reduce((s, l) => s + l.f, 0)) + 4).toFixed(1));
    flow.style.stroke = colors[chute.order];
    flow.setAttribute("opacity", chute.flow ? "1" : "0");
  }

  // Position horizontale (en % de la largeur affichée) du centre d'un compartiment, vue non zoomée.
  const percentOf = (pos) => ((byPos[pos].cx - viewBox[0]) / viewBox[2]) * 100;
  // focus : { pos } (un compartiment) ou { between: [a, b] } (la cloison entre deux compartiments).
  const setZoom = (k, focus) => {
    const x = focus.between ? (byPos[focus.between[0]].x1 + byPos[focus.between[1]].x0) / 2 : byPos[focus.pos].cx;
    const zh = 290, zw = zh * (viewBox[2] / viewBox[3]);
    const target = [x - zw / 2, -10, zw, zh];
    svg.setAttribute("viewBox", viewBox.map((v, i) => (v + (target[i] - v) * k).toFixed(1)).join(" "));
  };
  return { svg, comps, draw, setZoom, percentOf, destroy: () => { host.innerHTML = ""; } };
}

// Benne du dompeur : un seul volume aux coins du bas arrondis (benne demi-ronde), qui pivote sur la charnière
// arrière, poussé par un vérin télescopique à l'avant. Coordonnées de la benne à plat ; tilt en degrés.
const D = { x0: 352, x1: 1220, top: 110, floor: 258, r: 24, full: 0.9, hinge: [1228, 278], gate: [1232, 100], hoistBase: [326, 284], hoistTop: [327, 112], tilt: 15, rest: 4.5 };
// Plus haut que la citerne : la benne levée et le tas de grain derrière le camion.
export const DUMP_TRUCK_VIEWBOX = [-4, -150, 1380, 522];

const rotate = ([x, y], deg, [px, py]) => {
  const a = (deg * Math.PI) / 180, c = Math.cos(a), s = Math.sin(a);
  return [px + (x - px) * c - (y - py) * s, py + (x - px) * s + (y - py) * c];
};
const smooth = (k) => k * k * (3 - 2 * k);
function dumpCavity(s) {
  const x1 = D.x1 + s;
  const arc = (cx, cy, from) => Array.from({ length: 7 }, (_, i) => {
    const a = ((from + i * 15) * Math.PI) / 180;
    return [cx + D.r * Math.cos(a), cy + D.r * Math.sin(a)];
  });
  return [[D.x0, D.top], [x1, D.top], ...arc(x1 - D.r, D.floor - D.r, 0), ...arc(D.x0 + D.r, D.floor - D.r, 90)];
}
// Livraison en cours (unload.progress de 0 à 1) : la benne monte, verse, puis redescend à demi.
// Après une livraison, elle reste un peu levée, porte ouverte : c'est l'image d'une livraison de dompeur.
function dumpPose(kind, unload) {
  if (unload) {
    const k = unload.progress;
    const tilt = k < 0.2 ? D.tilt * smooth(k / 0.2) : k < 0.8 ? D.tilt : D.tilt + (D.rest - D.tilt) * smooth((k - 0.8) / 0.2);
    return { tilt, flow: k > 0.05, pile: smooth(Math.min(1, k / 0.85)), order: unload.order };
  }
  return kind === "deliv" ? { tilt: D.rest, flow: true, pile: 1 } : { tilt: 0, flow: false, pile: 0 };
}

function dumpMarkup(id, viewBox, s, label) {
  const u = (name) => `url(#${id}-${name})`;
  const cavity = P(dumpCavity(s));
  const rivets = Array.from({ length: 13 }, (_, i) => `<circle cx="344" cy="${118 + i * 11}" r="1.1" fill="rgba(0,0,0,.35)"/>`).join("");
  return `<svg viewBox="${viewBox.join(" ")}" aria-hidden="true">
    ${defs(id, `<clipPath id="${id}-clip"><polygon points="${cavity}"/></clipPath>`)}
    <g class="dmp-pile"><path/><path fill="${u("grain")}" opacity=".75"/><path fill="${u("shade")}"/></g>
    ${tractor(u)}
    <g>
      <rect x="316" y="272" width="${926 + s}" height="12" rx="2" fill="#22272e"/>
      <path d="M312,270 L348,270 L348,294 L320,294 Z" fill="#2b3138"/>
      <rect x="352" y="284" width="200" height="8" fill="#2b3138"/>
      <rect x="494" y="284" width="18" height="14" rx="2" fill="#2b3138"/><rect x="498" y="296" width="10" height="50" fill="${u("steelv")}"/><rect x="489" y="345" width="28" height="6" rx="1" fill="#2b3138"/>
      <rect x="${950 + s}" y="284" width="270" height="10" fill="#22272e"/>
      <rect x="${1212 + s}" y="266" width="28" height="24" rx="3" fill="#2b3138"/>
      <rect x="${1240 + s}" y="274" width="6" height="12" rx="1" fill="#dc2626"/>
    </g>
    <g class="dmp-box">
      <path d="M336,114 Q336,94 356,94 L${1222 + s},94 L${1222 + s},272 L370,272 Q336,272 336,240 Z" fill="${u("alu")}" stroke="#2b3138" stroke-width="1.2"/>
      <path d="M340,99 L${1220 + s},99" stroke="rgba(255,255,255,.75)" stroke-width="1.4"/>
      <path d="M340,108 L${1220 + s},108" stroke="rgba(0,0,0,.22)" stroke-width="1"/>
      ${rivets}
      <rect x="314" y="102" width="26" height="20" rx="3" fill="#2b3138"/>
      <rect x="${1214 + s}" y="266" width="24" height="12" rx="2" fill="#2b3138"/>
      <polygon points="${cavity}" fill="${u("inside")}"/>
      <g clip-path="url(#${id}-clip)">
        ${[0, 1].map((k) => `<path class="cst-fill" data-k="${k}"/><path class="cst-grain" data-k="${k}" fill="${u("grain")}" opacity=".75"/><path class="cst-shade" data-k="${k}" fill="${u("shade")}"/>`).join("")}
        <path class="cst-sep" fill="none" stroke="#fff" stroke-width="4"/>
      </g>
      <polygon points="${cavity}" fill="none" stroke="#1d232b" stroke-width="2"/>
      <polygon class="cst-out" points="${cavity}" fill="none"/>
      ${tape(384, 263, 820 + s)}
      <rect x="356" y="83" width="${856 + s}" height="11" rx="5.5" fill="#1f252c"/>
      <path d="M362,86.5 L${1206 + s},86.5" stroke="rgba(255,255,255,.22)" stroke-width="1.6"/>
      <g class="dmp-gate">
        <rect x="${1222 + s}" y="95" width="20" height="178" rx="3" fill="${u("alu")}" stroke="#2b3138" stroke-width="1.2"/>
        <rect x="${1225.5 + s}" y="106" width="13" height="150" rx="2" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="1"/>
        <rect x="${1226 + s}" y="200" width="12" height="40" rx="2" fill="#a3acb6" stroke="#4b5563" stroke-width=".9"/>
        <line x1="${1232 + s}" y1="208" x2="${1232 + s}" y2="232" stroke="#4b5563" stroke-width="2.2" stroke-linecap="round"/>
        <rect x="${1219 + s}" y="258" width="26" height="9" rx="2" fill="#2b3138"/>
        <circle cx="${1232 + s}" cy="100" r="4.5" fill="#2b3138"/>
      </g>
    </g>
    <g class="dmp-hoist"></g>
    <circle cx="${D.hinge[0] + s}" cy="${D.hinge[1]}" r="5.5" fill="#7d8792" stroke="#2b3138" stroke-width="1"/>
    ${label ? `<text class="cst-name dmp-name" x="${(D.x0 + D.x1 + s) / 2}" y="20">${label}</text>` : ""}
    ${running(u, s)}
    <path class="cst-flow dmp-out" fill="none" stroke-width="12" opacity="0"/>
    ${spoutMarkup(u)}
  </svg>`;
}

// Dompeur : même interface que createCompartmentTruck, avec une seule place, la benne (position 1).
// draw lit aussi kind et unload (livraison en cours) pour lever la benne, et orders pour la couleur du tas.
export function createDumpTruck(host, { colors, stretch: s = 0, label = "" }) {
  const id = `cst${++instance}`;
  const viewBox = [DUMP_TRUCK_VIEWBOX[0], DUMP_TRUCK_VIEWBOX[1], DUMP_TRUCK_VIEWBOX[2] + s, DUMP_TRUCK_VIEWBOX[3]];
  host.innerHTML = dumpMarkup(id, viewBox, s, label);
  const svg = host.querySelector("svg");
  const $ = (selector) => svg.querySelector(selector);
  const hinge = [D.hinge[0] + s, D.hinge[1]];
  const cavity = dumpCavity(s);
  const x1 = D.x1 + s, cx = (D.x0 + x1) / 2;
  const comps = [{ pos: 1, x0: D.x0, x1, cx, poly: [[D.x0, D.top], [x1, D.top], [x1, D.floor], [D.x0, D.floor]] }];
  const box = $(".dmp-box"), gate = $(".dmp-gate"), hoist = $(".dmp-hoist"), name = $(".dmp-name");
  const stream = $(".dmp-out"), pile = [...svg.querySelectorAll(".dmp-pile path")];
  const spout = $(".cst-spout"), flow = spout.querySelector(".cst-flow");

  // Niveau du grain (y du dessin) pour une part de la benne : le grain reste horizontal quand la benne se lève.
  const levelOf = (poly, area, frac) => {
    let lo = Math.min(...poly.map(([, y]) => y)), hi = Math.max(...poly.map(([, y]) => y));
    for (let k = 0; k < 26; k++) {
      const mid = (lo + hi) / 2;
      if (polyArea(clipBelow(poly, mid)) / area > frac) lo = mid; else hi = mid;
    }
    return (lo + hi) / 2;
  };
  // Ce niveau dans le repère de la benne, de l'avant vers l'arrière (ou l'inverse), bombé au milieu à plat.
  const surface = (level, tilt, reverse = false) => {
    const a = (tilt * Math.PI) / 180;
    const y = (x) => hinge[1] + (level - hinge[1] - (x - hinge[0]) * Math.sin(a)) / Math.cos(a);
    const [xa, xb] = reverse ? [x1 + 6, D.x0 - 6] : [D.x0 - 6, x1 + 6];
    const ya = y(xa), yb = y(xb);
    const mound = Math.min(9, Math.max(0, D.floor - Math.min(ya, yb)) * 0.1) * Math.max(0, 1 - tilt / 3);
    return { d: `${xa},${(ya + mound).toFixed(1)} Q${cx.toFixed(1)},${((ya + yb) / 2 - mound).toFixed(1)} ${xb},${(yb + mound).toFixed(1)}`, low: Math.max(ya, yb) };
  };
  const drawHoist = (tilt) => {
    const [bx, by] = D.hoistBase;
    const [tx, ty] = rotate(D.hoistTop, tilt, hinge);
    const step = (Math.hypot(tx - bx, ty - by) + 24) / 4;
    const angle = (Math.atan2(ty - by, tx - bx) * 180) / Math.PI;
    hoist.innerHTML = `<g transform="translate(${bx},${by}) rotate(${angle.toFixed(2)})">${[11, 15, 19, 24].map((w, i) => `<rect x="${((3 - i) * (step - 8)).toFixed(1)}" y="${-w / 2}" width="${step.toFixed(1)}" height="${w}" rx="2.5" fill="url(#${id}-chromeh)" stroke="#4b5563" stroke-width=".8"/>`).join("")}</g>
      <circle cx="${bx}" cy="${by}" r="6" fill="#7d8792" stroke="#2b3138"/><circle cx="${tx.toFixed(1)}" cy="${ty.toFixed(1)}" r="5" fill="#7d8792" stroke="#2b3138"/>`;
  };

  function draw({ fills = {}, hot = [], spout: chute = null, kind = "", unload = null, orders = [] }) {
    const { tilt, flow: pouring, pile: heap, order } = dumpPose(kind, unload);
    box.setAttribute("transform", tilt ? `rotate(${tilt.toFixed(2)} ${hinge[0]} ${hinge[1]})` : "");
    gate.setAttribute("transform", tilt ? `rotate(${(-Math.min(26, 8 + tilt * 1.2)).toFixed(2)} ${D.gate[0] + s} ${D.gate[1]})` : "");
    name?.setAttribute("opacity", tilt ? "0" : "1");
    box.querySelector(".cst-out").dataset.hot = hot.includes(1) ? "true" : "false";
    drawHoist(tilt);

    // Couches du bas vers le haut, comme dans la citerne ; un trait blanc les sépare.
    const poly = cavity.map((p) => rotate(p, tilt, hinge));
    const area = polyArea(poly);
    const layers = fills[1] || [];
    const sep = box.querySelector(".cst-sep");
    let below = 0;
    [0, 1].forEach((k) => {
      const layer = layers[k];
      const parts = ["cst-fill", "cst-grain", "cst-shade"].map((cls) => box.querySelector(`.${cls}[data-k="${k}"]`));
      if (!layer || layer.f <= 0.002) {
        parts.forEach((el) => el.setAttribute("d", ""));
        if (k === 1) sep.setAttribute("d", "");
        return;
      }
      const top = surface(levelOf(poly, area, (below + layer.f) * D.full), tilt);
      const under = below > 0.002 ? surface(levelOf(poly, area, below * D.full), tilt, true) : null;
      const bottom = Math.max(D.floor + 40, top.low + 10);
      const d = `M${top.d} ${under ? `L${under.d}` : `L${x1 + 6},${bottom.toFixed(1)} L${D.x0 - 6},${bottom.toFixed(1)}`} Z`;
      parts.forEach((el) => el.setAttribute("d", d));
      parts[0].setAttribute("fill", colors[layer.order]);
      if (k === 1) sep.setAttribute("d", under ? `M${surface(levelOf(poly, area, below * D.full), tilt).d}` : "");
      below += layer.f;
    });

    // Grain qui sort par la porte arrière et tas au sol derrière le camion.
    const color = colors[order || orders[0]] || "#64748b";
    const [ox, oy] = rotate([D.x1 + s + 16, D.floor + 4], tilt, hinge);
    const k = Math.sqrt(heap);
    stream.setAttribute("d", `M${ox.toFixed(1)},${oy.toFixed(1)} Q${(ox + 26).toFixed(1)},${(oy + 8).toFixed(1)} ${(ox + 34).toFixed(1)},${(356 - 24 * k).toFixed(1)}`);
    stream.style.stroke = color;
    stream.setAttribute("opacity", pouring ? "1" : "0");
    const pileD = k > 0.01 ? `M${(ox + 30 - 74 * k).toFixed(1)},360 Q${(ox + 30).toFixed(1)},${(360 - 80 * k).toFixed(1)} ${(ox + 30 + 74 * k).toFixed(1)},360 Z` : "";
    pile.forEach((el) => el.setAttribute("d", pileD));
    pile[0].setAttribute("fill", color);

    if (!chute) { spout.setAttribute("opacity", "0"); return; }
    spout.setAttribute("transform", `translate(${cx.toFixed(1)},0)`);
    spout.setAttribute("opacity", chute.alpha.toFixed(2));
    flow.setAttribute("y2", ((below > 0.002 ? levelOf(poly, area, below * D.full) : D.floor) + 4).toFixed(1));
    flow.style.stroke = colors[chute.order];
    flow.setAttribute("opacity", chute.flow ? "1" : "0");
  }

  const percentOf = () => ((cx - viewBox[0]) / viewBox[2]) * 100;
  return { svg, comps, draw, percentOf, destroy: () => { host.innerHTML = ""; } };
}
